import Text from '../Base/Text/Text';
import styles from './DoctorItem.module.scss';

export default function DoctorItem(props) {
	const { user, onClick } = props;

	const handleClick = () => {
		onClick?.({
			id: user.id,
			label: user.label,
		});
	};

	return (
		<div
			className='autocomplete-custom-patient-search no-border'
			onClick={handleClick}>
			<div className='autocomplete-custom-patient-search__content'>
				<div className='autocomplete-custom-patient-search__content__title'>
					<Text tx={user.label} />
				</div>
			</div>
		</div>
	);
}

DoctorItem.propTypes = {};
